

import { defineComponent } from 'vue'
import { useSearchParam } from '@/hooks/app'

export default defineComponent({
  name: 'Search',
  setup: () => ({
    search: useSearchParam(),
  }),
})
